<!-- 山留めセンサー図面エディタ -->
<div class="drawing-tilt-editor">
  <!-- 操作ボタン -->
  <div class="controls">
    <button mat-raised-button color="primary" (click)="onUploadClick()">
      <mat-icon>upload</mat-icon>
      図面画像アップロード
    </button>
  </div>

  <!-- 図面表示エリア -->
  <div class="drawing-container">
    <svg
      id="svg-tilt"
      [attr.width]="svgWidth"
      [attr.height]="svgHeight"
      (mousemove)="onSvgMouseMove($event)"
      (mouseup)="onMouseUp()"
      (mouseleave)="onMouseUp()"
      class="drawing-svg"
    >
      <!-- 各山留めセンサーのマーカー（図面がアップロードされている場合のみ表示） -->
      <g
        *ngFor="let sensor of drawingSensors"
        class="sensor-marker"
        (mousedown)="onMarkerMouseDown($event, sensor)"
      >
        <!-- マーカーの円 -->
        <circle
          *ngIf="isImageLoaded"
          [attr.cx]="sensor.x"
          [attr.cy]="sensor.y"
          [attr.r]="MARKER_RADIUS"
        />
        <!-- 位置名称テキスト -->
        <text
          *ngIf="isImageLoaded"
          [attr.x]="sensor.x"
          [attr.y]="sensor.y"
          text-anchor="middle"
          dominant-baseline="middle"
        >
          {{ getPositionIndex(sensor) }}
        </text>
      </g>
    </svg>

    <!-- センサー未設定メッセージ -->
    <div *ngIf="drawingSensors.length === 0" class="no-sensors-message">
      <mat-icon>info</mat-icon>
      <p>この現場には山留めセンサーが設定されていません</p>
    </div>
  </div>

  <!-- 保存・キャンセルボタン -->
  <div class="actions">
    <button mat-raised-button color="accent" (click)="onCancel()">
      <mat-icon>cancel</mat-icon>
      キャンセル
    </button>
    <button
      mat-raised-button
      color="primary"
      (click)="onSave()"
      [disabled]="drawingSensors.length === 0"
    >
      <mat-icon>save</mat-icon>
      保存して一覧に戻る
    </button>
  </div>
</div>
